/* 
This is component to control speakers. We are controlling the volume using bar which have onChange listner.
this listner call a "volumeChange" function which have timeout which call the API after 200ms becuase 
onChange get call too frequently.
"buttonColor" is a method which used to set color of all button according to color config from CMS.
"buttonColor" this is to change font color of the selcted button from input.
*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { buttonColor, onControlClick, listOnSelect } from '../../JS/setColors'
import {
    setVolume, getSpeakerStatus,
    changeSpeaker, sourceChange,
    getSpeakerList, setZoneAPI,
    setSourceForAll
} from '../../action/roomControlAction'
import { popupOpenClose, setLoadingMass } from '../../action/action'
import { speakerList, changeVolume, speakerSetZoneAction } from '../../config/constant'

class SpeakerControl extends Component {
    constructor(props) {
        super(props);
        this.volumeTimeout = 0
        this.state = {
            currentVolume: 50
        }
    }

    componentDidMount() {
        //this.props.getSpeakerList(speakerList);
        buttonColor(this.props.menuColor);
        this.setState({
            currentVolume:
                this.props.selectedSpeaker && this.props.selectedSpeaker.currentVolume ?
                    this.props.selectedSpeaker.currentVolume : 50
        });
        if (this.props.currentSongSource) {
            document.getElementById("playOnAllSpeaker").checked = true
        }
        this.props.getSpeakerStatus(
            "roomControl", this.props.guestDetail
        );
    }
    speakerConnectCallBack = (status, controller) => {
        console.log("controller", controller)
        this.props.setLoadingMass(false);
        if (controller === "BLUETOOTH") {
            if (status) {
                onControlClick(controller, "speaker", this.props.menuColor);
                this.props.popupOpenClose(true, "Bluetooth source activated succesfully.");
            } else {
                this.props.popupOpenClose(true, "Please connect to speaker from phone Bluetooth.");
                //  `Please connect to speaker from bluetooth setting with name "${this.props.selectedSpeaker.bluetoothName?this.props.selectedSpeaker.bluetoothName:""}"`);
            }
        }
        else if (controller === "BLUETOOTH_OFF") {
            if (status) {
                onControlClick(controller, "speaker", this.props.menuColor);
                this.props.popupOpenClose(true, "Disconnected Successfully.");
            } else {
                this.props.popupOpenClose(true, "Sorry, can't able to Disconnected speaker bluetooth.");
            }
        } else {
            if (status) {
                onControlClick(controller, "speaker", this.props.menuColor);
                this.props.popupOpenClose(true, "Connected Successfully.");
            } else {
                this.props.popupOpenClose(true, "Sorry, can't able to connect to speaker.");
            }
        }
    }
    componentDidUpdate() {
        listOnSelect(this.props.menuColor);
    }
    buttonClick = (id, mode) => {
        if (id === "TV") {
            if (this.props.guestDetail.locationId) {
                this.props.sourceChange(
                    "changeSource", "TV", this.props.guestDetail,
                    this.props.selectedSpeaker,
                    this.speakerConnectCallBack
                );
                // this.props.getSpeakerStatus(
                //     "speakerControl", this.props.guestDetail,
                //     this.speakerConnectCallBack
                // );
            } else {
                console.log("we are not getting location ID to get connect speaker.");
            }
            onControlClick(id, mode, this.props.menuColor);
            this.props.setLoadingMass(true);
        } else if (id === "BLUETOOTH") {
            onControlClick(id, mode, this.props.menuColor);
            this.props.setLoadingMass(true);
            this.props.sourceChange(
                "changeSource", "BLUETOOTH", this.props.guestDetail,
                this.props.selectedSpeaker,
                this.speakerConnectCallBack
            );
        } else if (id === "BLUETOOTH_OFF") {
            onControlClick("TV", mode, this.props.menuColor);
            this.props.setLoadingMass(true);
            this.props.sourceChange(
                "changeSource", "BLUETOOTH_OFF", this.props.guestDetail,
                this.props.selectedSpeaker,
                this.speakerConnectCallBack
            );
        }
    }

    callSpeakerStatusAPI = () => {
        console.log("callSpeakerStatusAPI called");
        this.props.getSpeakerStatus(
            "speakerControl", this.props.guestDetail
        );
    }

    callBackFunction = () => {
        this.props.popupOpenClose(true, "sorry,can't connect to the speaker.");
        this.setState({
            currentVolume:
                this.props.selectedSpeaker.currentVolume ?
                    this.props.selectedSpeaker.currentVolume : 50
        });
    }

    volumeChange = (event) => {
        let volChange, incORdecVolume;
        if (this.props.selectedSpeaker.currentSource) {
            this.setState({ currentVolume: event.target.value });
        }
        window.clearTimeout(this.volumeTimeout);
        this.volumeTimeout = setTimeout((event) => {
            console.log("event", this.state.currentVolume);
            if (this.props.selectedSpeaker.currentSource) {
                //volChange = this.props.speakerSource.currentVolume - this.state.currentVolume
                if (this.props.guestDetail.locationId) {
                    this.props.setVolume(
                        this.state.currentVolume, changeVolume, this.props.selectedSpeaker,
                        this.props.guestDetail, this.callBackFunction
                    );
                } else {
                    console.log("we are not getting location ID to get connect speaker.");
                }
            } else {
                this.props.popupOpenClose(true, "Input source is not selected.");
            }
        }, 200);
    }

    selectSpeaker = (speaker) => {
        if (speaker) {
            this.setState({ currentVolume: speaker.currentVolume });
        }
        //console.log("speaker", speaker);
        this.props.changeSpeaker(speaker);
    }

    playOnALL = () => {
        //console.log("value", document.getElementById("playOnAllSpeaker").checked)
        if (this.props.selectedSpeaker.currentSource) {
            if (document.getElementById("playOnAllSpeaker").checked === true) {
                //console.log("@@@", this.props.selectedSpeaker);
                this.props.setZoneAPI(
                    this.props.guestDetail,
                    this.props.selectedSpeaker,
                    speakerSetZoneAction
                );
                this.props.setSourceForAll(this.props.selectedSpeaker.currentSource);
                // window.setTimeout(() => {
                //     this.callSpeakerStatusAPI();
                // }, 2000);
            } else {
                //document.getElementById("playOnAllSpeaker").checked = true;
                this.props.popupOpenClose(true, "This is in progress so disconnecting speaker may not work.");
                this.props.setSourceForAll(null);
            }
        } else {
            this.props.popupOpenClose(true, "Plaese select source to play on all.");
            document.getElementById("playOnAllSpeaker").checked = false
        }
    }

    render() {
        return (
            <div id="controls-speaker" className="rc-controls w-100">
                <h2>Speaker controls</h2>
                <div id="speaker-selection" class="tiles"
                    style={this.props.selectedSpeaker ? { display: "none" } : { color: "inherit" }}>
                    <p style={{ color: "inherit" }}>
                        <strong style={{ color: "inherit" }}>Please select a speaker</strong>
                    </p>
                    <ul class="tile-links" data-parent="speaker-selection">
                        {this.props.speakerList.length > 0 ?
                            this.props.speakerList.map((iterator) => {
                                return (
                                    <li onClick={() => { this.selectSpeaker(iterator) }}>
                                        <button data-target={iterator.name}
                                            style={{
                                                background: `${this.props.menuColor.assetBackgroundSelectorColor ?
                                                    this.props.menuColor.assetBackgroundSelectorColor : ""}`
                                            }}>
                                            <i class="fa fa-volume-off"></i>
                                            {iterator.name}
                                        </button>
                                    </li>
                                )
                            }) : null
                        }
                    </ul>
                </div>
                <div id={`speaker-${this.props.selectedSpeaker ? this.props.selectedSpeaker.id : null}`}
                    class="speaker-main tile-target"
                    style={this.props.selectedSpeaker ? {} : { display: "none" }}>
                    <button
                        onClick={() => { this.selectSpeaker(null) }}
                        class="return-button button" data-target="speaker-selection">
                        Back to selection
                    </button>
                    <div class="controls"
                        style={{
                            display: "none",
                            position: "relative", margin: "1rem 0",
                            paddingTop: "1rem", borderTop: "1px solid #999",
                            height: "4rem"
                        }}>
                        <p
                            style={{
                                marginBottom: 0, marginRight: "1rem",
                                marginTop: "0.75rem", display: "inline-block"
                            }}>
                            <strong>Play audio on all speakers </strong>
                        </p>
                        <label class="switch" style={{ position: "absolute" }}>
                            <input id="playOnAllSpeaker" type="checkbox" class="use-all-toggle" onClick={this.playOnALL} />
                            <span class="slider round"></span>
                        </label>
                    </div>
                    <p><strong>Input</strong></p>
                    <button
                        id="BLUETOOTHSpeaker"
                        onClick={() => {
                            this.buttonClick(
                                "BLUETOOTH"
                                , "speaker")
                        }}
                        className={this.props.currentSongSource && this.props.currentSongSource === "BLUETOOTH" ?
                            "button selected w-100"
                            : !this.props.currentSongSource && this.props.selectedSpeaker &&
                                this.props.selectedSpeaker.currentSource === "BLUETOOTH" ?
                                "button selected w-100" : "button w-100"
                        }>
                        {
                            this.props.selectedSpeaker &&
                                this.props.selectedSpeaker.id === "BATHROOM_SPEAKER" ?
                                "Bluetooth On" : "Bluetooth"
                        }
                    </button>
                    <button
                        id="TVSpeaker"
                        onClick={() => {
                            this.buttonClick(
                                `${
                                this.props.selectedSpeaker &&
                                    this.props.selectedSpeaker.id === "BATHROOM_SPEAKER" ?
                                    "BLUETOOTH_OFF" : "TV"
                                }`,
                                "speaker")
                        }}
                        className={
                            this.props.currentSongSource && this.props.currentSongSource === "TV" ?
                                "button selected w-100"
                                : this.props.selectedSpeaker ?
                                    !this.props.currentSongSource && this.props.selectedSpeaker.currentSource === "TV" ?
                                        "button selected w-100"
                                        : this.props.selectedSpeaker.id === "BATHROOM_SPEAKER" && this.props.selectedSpeaker.currentSource === "BLUETOOTH_OFF" ?
                                            "button selected w-100" : "button w-100"
                                    : "button w-100"
                        }>
                        {
                            this.props.selectedSpeaker &&
                                this.props.selectedSpeaker.id === "BATHROOM_SPEAKER" ?
                                "Bluetooth Off" : "TV"
                        }
                    </button>
                    <p><strong>Volume controls</strong></p>
                    <div className="controls" style={{ textAlign: "center" }}>
                        <div class="volume-value center">
                            {this.state.currentVolume}
                        </div>
                        <div class="slidecontainer">
                            <input
                                type="range"
                                min={this.props.selectedSpeaker ?
                                    this.props.selectedSpeaker.minimumVolume : 0}
                                max={this.props.selectedSpeaker ?
                                    this.props.selectedSpeaker.maximumVolume : 100
                                }
                                value={this.state.currentVolume}
                                class="rangeSlider"
                                id="myRange"
                                onChange={this.volumeChange}
                            />
                        </div>
                        {/* <a
                        id="speakerVolUp"
                        onClick={() => { this.buttonClick("speakerVolUp", "speaker") }}
                        className="button w-40">
                        <i className="fa fa-plus"></i>
                    </a>
                    <a
                        id="speakerVoldown"
                        onClick={() => { this.buttonClick("speakerVoldown", "speaker") }}
                        className="button w-40">
                        <i className="fa fa-minus"></i>
                    </a> */}
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        currentControl: state.store.roomControl.currentControl,
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor,
        speakerSource: state.store.roomControl.speakerSource,
        currentSongSource: state.store.roomControl.currentSongSource,
        guestDetail: state.store.home.guestDetails,
        selectedSpeaker: state.store.roomControl.selectedSpeaker,
        speakerList: state.store.roomControl.speakerList,
        speakerZone: state.store.roomControl.speakerZone
    }
}

export default connect(
    mapStateToProps,
    {
        setVolume,
        popupOpenClose,
        getSpeakerStatus,
        setLoadingMass,
        changeSpeaker,
        sourceChange,
        getSpeakerList,
        setZoneAPI,
        setSourceForAll
    }
)(SpeakerControl);

